import * as React from 'react';
import styled from '@emotion/styled';
import { transparentize } from 'polished';
import { FaTrashAlt } from 'react-icons/fa';
import { toIgnoreRuleRawRecord } from './util';
import { IconButton } from '../../components';
const TableContainer = styled.div `
  overflow: auto;
  height: 40%;

  table {
    border-spacing: 0;
    border: 1px solid ${(props) => props.theme.borderColour};
    border-left: none;
    border-right: none;

    tr {
      :last-child {
        td {
          border-bottom: 0;
        }
      }
      &.selected {
        background: ${(props) => transparentize(0.8, props.theme.activeColour)};
      }
    }

    th,
    td {
      margin: 0;
      padding: 0.5rem;
      border-bottom: 1px solid ${(props) => props.theme.borderColour};
      border-right: none;
      border-left: none;

      :last-child {
        border-right: 0;
      }
    }

    th {
      color: #737373;
      text-align: left;
    }
  }
`;
const colsDisplayFilter = ({ accessor }) => accessor !== 'logsMustExistPatterns';
export const Table = ({ columns, ignoreRules, selectedId, setSelectedId, deleteRule, }) => {
    return (React.createElement(TableContainer, null,
        React.createElement("table", null,
            React.createElement("thead", null,
                React.createElement("tr", null,
                    columns.filter(colsDisplayFilter).map(({ header }, i) => (React.createElement("th", { key: i }, header))),
                    React.createElement("th", null))),
            React.createElement("tbody", null, ignoreRules.map(toIgnoreRuleRawRecord).map((row, i) => (React.createElement("tr", { key: i, onClick: () => setSelectedId(row.id), className: row.id === selectedId ? 'selected' : '' },
                columns.filter(colsDisplayFilter).map((col, i) => (React.createElement("td", { key: i }, row[col.accessor]))),
                React.createElement("td", null,
                    React.createElement(IconButton, { onClick: () => deleteRule(row.id) },
                        React.createElement(FaTrashAlt, null))))))))));
};
//# sourceMappingURL=table.js.map